<template>
    <b-row>
        <b-col cols="12">
            <h4>
                <strong>
                    Le recordamos que las liquidaciones se realizarán los Miércoles de cada semana.
                </strong>
                <br/>
                <strong>
                    Cualquier consulta nos tiene a su disposición.
                </strong>    
            </h4>                                            
        </b-col>
        <b-col cols="12" class="mt-3">
            <b-button @click="continuar">
                Continuar
            </b-button>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        methods: {
            continuar() {
                this.$emit('continuar');
            }
        }
    }
</script>
